import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Card, CardBody } from "reactstrap";

function WorkerStatusStrip({ isActive, isActionRequired, reason, t }) {
  const trimmedReason =
    typeof reason === "string" && reason.trim() ? reason.trim() : "";

  let hint = "";
  if (!isActive) {
    if (isActionRequired && trimmedReason) {
      hint = trimmedReason;
    } else {
      hint = t(
        "workerDashboardStatusActionHint",
        "Update your availability or complete your profile to start receiving assignments."
      );
    }
  }

  return (
    <Card
      className={`worker-dashboard-status border-0 mb-4 ${
        isActive
          ? "worker-dashboard-status--active"
          : "worker-dashboard-status--action"
      }`}
    >
      <CardBody className="p-3 p-md-4 d-flex align-items-center gap-3">
        <span
          className="worker-dashboard-status__icon"
          aria-hidden="true"
        >
          <i
            className={`bx ${
              isActive ? "bx-check-circle" : "bx-error-circle"
            }`}
          />
        </span>
        <div>
          <div className="worker-dashboard-status__label">
            {isActive
              ? t("workerDashboardStatusActive", "Active and ready to work")
              : isActionRequired
                ? t("workerDashboardStatusActionRequired", "Action required")
                : t(
                    "workerDashboardStatusInactive",
                    "Not currently available for work"
                  )}
          </div>
          {hint ? (
            <p
              className={`worker-dashboard-status__hint mb-0${
                isActionRequired && trimmedReason
                  ? " worker-dashboard-status__hint--reason"
                  : ""
              }`}
            >
              {hint}
            </p>
          ) : null}
        </div>
      </CardBody>
    </Card>
  );
}

WorkerStatusStrip.propTypes = {
  isActive: PropTypes.bool.isRequired,
  isActionRequired: PropTypes.bool,
  reason: PropTypes.string,
  t: PropTypes.func,
};

export default withTranslation()(WorkerStatusStrip);
